export default __webpack_public_path__ + "static/media/save-icon.0ee2cd27.svg";